import { Component, HostBinding, Input } from '@angular/core';
import { StringHelper } from '../../../helpers/string.helper';
import { SpinnerSizeEnum } from './types/spinner-size.enum';
import { SpinnerColorEnum } from './types/spinner-color.enum';

@Component({
  selector: 'l-spinner',
  standalone: true,
  template: `
    <div [class]="containerClass">
      <svg xmlns="http://www.w3.org/2000/svg" [class]="svgClasses" fill="none" viewBox="0 0 100 100">
        <circle class="opacity-25" cx="50" cy="50" r="35" stroke-width="8"></circle>
        <circle
          cx="50"
          cy="50"
          r="35"
          stroke-width="8"
          stroke-dasharray="164.93361431346415 56.97787143782138"
          stroke-linecap="round"
        ></circle>
      </svg>
    </div>
  `,
})
export class SpinnerComponent {
  @Input()
  public set size(value: SpinnerSizeEnum | string) {
    this._size = StringHelper.stringToEnum(SpinnerSizeEnum, value) || SpinnerSizeEnum.LARGE;
  }

  @Input()
  public set color(value: SpinnerColorEnum | string) {
    this._color = StringHelper.stringToEnum(SpinnerColorEnum, value) || SpinnerColorEnum.PRIMARY;
  }

  @Input()
  public set overlay(value: boolean | string) {
    this._overlay = typeof value === 'string' ? value === '' || value === 'true' : value;
  }

  private _size: SpinnerSizeEnum = SpinnerSizeEnum.LARGE;
  private _color: SpinnerColorEnum = SpinnerColorEnum.PRIMARY;
  private _overlay = false;

  @HostBinding('class')
  public get containerClass(): string {
    return this._overlay
      ? 'absolute inset-0 z-50 flex items-center justify-center h-full'
      : 'inline-flex items-center justify-center h-full';
  }

  public get svgClasses(): string {
    const sizes = {
      [SpinnerSizeEnum.SMALL]: 'w-6 h-6',
      [SpinnerSizeEnum.MEDIUM]: 'w-12 h-12',
      [SpinnerSizeEnum.LARGE]: 'w-20 h-20',
    };

    const colors = {
      [SpinnerColorEnum.PRIMARY]: 'text-lPrimary',
      [SpinnerColorEnum.GRAY]: 'text-lGray100',
      [SpinnerColorEnum.WHITE]: 'text-white',
    };

    return `${sizes[this._size]} animate-spin ${colors[this._color]} stroke-current`;
  }
}

